// extracted by mini-css-extract-plugin
export default {"coloredTitle":"MemoModal_coloredTitle__0gqVD"};